import type { Material, Project, Task, User, WorkLogEntry } from "../types";

export const DATA_CACHE_KEY = "rio_cached_data";

export interface CachedAppData {
  projects: Project[];
  tasks: Task[];
  workLogs: WorkLogEntry[];
  materials: Material[];
  users: User[];
}

export function readCachedData(): Partial<CachedAppData> {
  if (typeof window === "undefined") return {};
  try {
    const raw = localStorage.getItem(DATA_CACHE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return typeof parsed === "object" && parsed !== null ? parsed : {};
  } catch {
    return {};
  }
}

export function writeCachedData(snapshot: Partial<CachedAppData>): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(
      DATA_CACHE_KEY,
      JSON.stringify({ ...readCachedData(), ...snapshot }),
    );
  } catch {}
}

export function syncCachedUsers(users: User[]): void {
  writeCachedData({ users });
}

export function clearCachedUsers(): void {
  if (typeof window === "undefined") return;
  try {
    const cached = readCachedData();
    if (!("users" in cached)) return;
    delete cached.users;
    if (Object.keys(cached).length === 0) {
      localStorage.removeItem(DATA_CACHE_KEY);
    } else {
      localStorage.setItem(DATA_CACHE_KEY, JSON.stringify(cached));
    }
  } catch {}
}
